import { Box, Grid2, IconButton, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import MontyPayLogo from "@assets/Images/MontyPayLogo.webp";

const StatusModal = ({ paymentStatus, statusDescription, icon }) => {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={(e, reason) => {
        if (reason !== "backdropClick") handleClose();
      }}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center"}}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          width: { xs: "90%", sm: "470px" },
          outline: "none",
          
        }}
      >
        <Grid2 container direction="column" alignItems="center">
          <Grid2
            size={12}
            sx={{
              backgroundColor: "#03358e",
              width: "100%",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              padding: "15px 15px 15px 24px",
              position: "relative",
              borderRadius: "12px 12px 0 0",
            }}
          >
            <img src={MontyPayLogo} alt="MontyPay Logo" style={{ height: "30px" }} />
            
          </Grid2>
          <Grid2 size={12} sx={{ padding: "24px", textAlign: "left" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              {icon}
              <Box>
                <Typography variant="h6" sx={{ fontFamily: "Manrope-SemiBold", color: "#03358e" }}>
                  {paymentStatus}
                </Typography>
                <Typography variant="body2" sx={{ fontFamily: "Manrope-Regular" }}>
                  {statusDescription}
                </Typography>
              </Box>
            </Box>
          </Grid2>
        </Grid2>
      </Box>
    </Modal>
  );
};

export default StatusModal;
